export const MOBILE_BREAKPOINT_PX = 768
export const PHONE_LANDSCAPE_QUERY =
  '(max-width: 1023px) and (max-height: 500px) and (orientation: landscape)'
export const MOBILE_LAYOUT_QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX - 1}px), ${PHONE_LANDSCAPE_QUERY}`
